import { atom } from "recoil";

export const priceRulesState = atom({
  key: "statRulesGroupsApplied",
  default: [],
});

export const marketGroupState = atom({
  key: "marketGroupState",
  default: {},
});

export const fixtureState = atom({
  key: "fixtureState",
  default: {},
});
